module.exports = __webpack_public_path__ + "static/media/andrehh.6e84d3c3.svg";